import React from 'react'

const LetsBuild = () => {
    return (
        <a href="#contactsec" style={{ textDecoration: "none", border: "none" }}>
            <button className="appdevprocess-btn-primary">
                Let's Build Together
            </button>
        </a>
    )
}

export default LetsBuild